import { createContext, useContext } from 'react';
import { KeyboardNavigationContextValue } from './types';

export const KeyboardNavigationContext = createContext<KeyboardNavigationContextValue | null>(null);

export function useKeyboardNavigationContext() {
	const context = useContext(KeyboardNavigationContext);

	if (!context) {
		throw new Error(
			'useKeyboardNavigationContext must be used within a KeyboardNavigationProvider',
		);
	}

	return context;
}
